import React, { useState } from 'react';
import countriesData from '../assets/countries.json';
import citiesData from '../assets/cities.json';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile: '',
        company: '',
        country: '',
        city: '',
        subject: '',
        message: ''
      });
      const [response, setResponse] = useState(null);
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        setResponse(null);
        try {
          const res = await fetch('/api/contact.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
          });
          const result = await res.json();
          setResponse(result.message); 
          setTimeout(() => {
            setResponse('');
            }, 3000);
        } catch (error) {
          console.error('Error:', error);
        }
      };

      const [selectedCountry, setSelectedCountry] = useState('');
      const [selectedCity, setSelectedCity] = useState('');
      const [showCity, setShowCity] = useState(false);

      const handleCountryChange = (event) => {
        setShowCity(false);
        setSelectedCity('');
        setSelectedCountry(event.target.value);
        setFormData({ ...formData, "country": event.target.value });
        if(event.target.value === 'United Arab Emirates') {
            setShowCity(true);
        }
      };
      
      const handleCityChange = (event) => {
        setSelectedCity(event.target.value);
        setFormData({ ...formData, "city": event.target.value });
      };

    return (
        <>
            <section id="contact" className="contact section">
                <div className="container" data-aos="fade-up" data-aos-delay="100">
                    <form method="post" className="php-email-form" data-aos="fade-up" data-aos-delay="400" onSubmit={handleSubmit}>
                        <div className="row gy-4">
                            <div className="col-md-6">
                                <input type="text" className="form-control" name="name" placeholder="Your Name" onChange={handleChange} required />
                            </div>
                            <div className="col-md-6 ">
                                <input type="email" className="form-control" name="email" placeholder="Your Email" onChange={handleChange} required />
                            </div>
                            <div className="col-md-6">
                                <input type="text" className="form-control" name="mobile" placeholder="Your Mobile" onChange={handleChange} required />
                            </div>
                            <div className="col-md-6 ">
                                <input type="text" className="form-control" name="company" placeholder="Your Company" onChange={handleChange} required />
                            </div>
                            <div className="col-md-6">
                               <select id="country-select" value={selectedCountry} onChange={handleCountryChange}>
                                    <option value="">-- Select a Country --</option>
                                    {countriesData.map((country) => (
                                    <option key={country.id} value={country.name}>
                                        {country.name}
                                    </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-6">
                                {showCity && 
                                    <select id="country-city" value={selectedCity} onChange={handleCityChange}>
                                        <option value="">-- Select a City --</option>
                                        {citiesData.map((city) => (
                                        <option key={city.id} value={city.name}>
                                            {city.name}
                                        </option>
                                        ))}
                                    </select>
                                }
                            </div>
                            <div className="col-md-12">
                                <input type="text" className="form-control" name="subject" placeholder="Subject" onChange={handleChange} required />
                            </div>
                            <div className="col-md-12">
                                <textarea className="form-control" name="message" rows="6" placeholder="Message" onChange={handleChange} required></textarea>
                            </div>
                            <div className="col-md-12 text-center pb-40">
                                <button className='theme-btn style-two' type="submit">Send Message</button>
                                {response && <div className='alert alert-info'>{response}</div>}
                            </div>
                        </div>
                    </form>
                    
                </div>
            </section>
        </>
    );
};

export default ContactForm;